import { sortInboxMessageList } from "@/lib/mail/folderWarmup";
import { isInboxRowExitPinned } from "@/lib/mail/inboxRowExit";
import type { MailMessageSummary } from "@/lib/types/mail";

export type UnifiedMailMessage = MailMessageSummary & {
  accountId: number;
  imapFolder: string;
};

export function unifiedMessageKey(accountId: number, uid: number): string {
  return `${accountId}:${uid}`;
}

export function tagMessageForAccount(
  accountId: number,
  folder: string,
  message: MailMessageSummary
): UnifiedMailMessage {
  return {
    ...message,
    accountId,
    imapFolder: folder,
  };
}

/** Fusionne les INBOX. Après une 1ʳᵉ liste : flags sur place (pas de re-tri flash Gmail). */
export function mergeUnifiedInboxMessages(
  batches: UnifiedMailMessage[][],
  previous?: UnifiedMailMessage[] | null
): UnifiedMailMessage[] {
  if (batches.length === 0) return [];
  const merged = batches.flat();
  if (!previous?.length) {
    return sortInboxMessageList(merged) as UnifiedMailMessage[];
  }

  const nextMap = new Map(merged.map((m) => [unifiedMessageKey(m.accountId, m.uid), m]));
  const prevKeys = new Set(previous.map((m) => unifiedMessageKey(m.accountId, m.uid)));

  const kept = previous
    .map((m) => {
      const key = unifiedMessageKey(m.accountId, m.uid);
      const incoming = nextMap.get(key);
      if (incoming) return incoming;
      if (isInboxRowExitPinned(m.accountId, m.imapFolder || "INBOX", m.uid)) return m;
      return null;
    })
    .filter((m): m is UnifiedMailMessage => m != null);

  const brandNew = merged
    .filter((m) => !prevKeys.has(unifiedMessageKey(m.accountId, m.uid)))
    .sort((a, b) => b.uid - a.uid);

  return [...brandNew, ...kept];
}

export function countUnifiedUnread(messages: UnifiedMailMessage[]): number {
  return messages.filter((m) => !m.seen).length;
}
